window.arFreelancerFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/relations/show/'+row.freelancer_id+'">';
    html += value;
    html += '</a>';
    return html;
}
